export default __webpack_public_path__ + "static/media/india_powerline_distribution.c63fa3b1.png";